import { isEqual } from "es-toolkit";

import type { PlotGrid } from "./gridUtils";
import {
  canRedoHistory,
  canUndoHistory,
  createUndoHistoryReducer,
  type UndoHistoryState,
} from "./undoHistory";

/** Committed meshes and pre-commit lattices can both sit on the undo stack. */
export const hasRecordableGridHistory = (grid: PlotGrid): boolean => {
  if (grid.isCommitted) {
    return grid.mesh != null;
  }

  return (
    grid.rows != null &&
    grid.columns != null &&
    grid.plotLengthMeters != null &&
    grid.plotWidthMeters != null
  );
};

export interface GridHistorySnapshot {
  grid: PlotGrid;
  selectedCellIds: string[];
}

export type GridHistoryState = UndoHistoryState<GridHistorySnapshot>;

export const canUndoGridHistory = canUndoHistory<GridHistorySnapshot>;

export const canRedoGridHistory = canRedoHistory<GridHistorySnapshot>;

export const gridHistoryReducer = createUndoHistoryReducer<GridHistorySnapshot>(
  {
    isCommitEqual: (baseline, next) => isEqual(baseline.grid, next.grid),
  },
);
